import BaseStore from "@/store/baseStore";
import api from "../api/api"

export const namespaced = true;

const baseURI = '/years/'
const baseStore = new BaseStore(baseURI);

const getDefaultState = () => {
    return {
        ...baseStore.state,
        base: {
            'id': '',
            'year': '',
        },
    };
};

export const state = getDefaultState();

export const mutations = {
    ...baseStore.mutations,
    resetState(state) {
        Object.assign(state, getDefaultState());
    },

}
export const actions = {
    ...baseStore.actions,
    resetState(context) {
        context.commit("resetState");
    },
    async updateSelectedYear(context, {id, selectedYear}) {
        const url = `/project_user/${id}/`
        await api.patch(url, {selected_year: selectedYear.id})
        await context.dispatch('project/updateYear', selectedYear.id, {root: true});
    },
}

export const getters = {}




